import { useEffect, useState } from "react";

import { getIsPartner } from "@/utils/getIsPartner";

export function useLocalSettings() {
  const [isPartner, setIsPartner] = useState(false);
  const retrievePartnerStatus = () => {
    setIsPartner(getIsPartner());
  };
  useEffect(() => {
    retrievePartnerStatus();
  }, []);
  return { isPartner };
}
